import React from "react";
import { Row, Col, Alert } from 'reactstrap';

const SigninForm = (props) => {
    const { onSubmit, isLoading, loginError } = props;
    return (
        <form onSubmit={onSubmit}>
            <Row>
                <Col xs={{ "size": 10, "offset": 1 }} >
                    {
                        loginError && (
                            <Alert color="danger" className="my-3">
                                <div className="alert-message">
                                    {loginError}
                                </div>
                            </Alert>
                        )
                    }
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Email"
                            name="email"
                            className="form-control-lg form-control"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            placeholder="Password"
                            name="password"
                            className="form-control-lg form-control"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={{ "size": 6, "offset": 3 }} className="mt-4">
                	<div className="text-center">
                		<button className="btn-rounded btn-dark-blue btn btn-primary btn-lg btn-block">Submit</button>
                	</div>
                </Col>
            </Row>
        </form>
    )
}

export default SigninForm;